/**
 * Ein gemeinsamer Weg, das Access-Token zu erneuern -- fuer den api-Client
 * (services/api.ts) und den globalen axios-Interceptor (AuthContext).
 *
 *  - SSO: Refresh bei Keycloak mit dem Refresh-Token aus dem Speicher.
 *  - Lokaler Passwortfluss: POST /api/auth/refresh, das Refresh-Token kommt
 *    aus dem HttpOnly-Cookie und wird dabei rotiert.
 *
 * Gleichzeitige Aufrufe teilen sich eine Anfrage. Beim lokalen Fluss ist das
 * Pflicht: das Cookie wird rotiert, ein zweiter paralleler Refresh mit dem
 * alten Cookie liefe in 401 und meldete die Person ab.
 */
import authService from './auth.service';
import { isOidcConfigured, refreshAccessToken as refreshBeiKeycloak } from './authService';
import { setAccessToken } from './tokenStore';

let laufend: Promise<string> | null = null;

async function erneuern(): Promise<string> {
  if (isOidcConfigured()) return refreshBeiKeycloak();
  const { accessToken } = await authService.refreshToken();
  setAccessToken(accessToken);
  return accessToken;
}

export function refreshSession(): Promise<string> {
  if (!laufend) {
    laufend = erneuern().finally(() => {
      laufend = null;
    });
  }
  return laufend;
}
